import React from 'react';
import PanelMeasure from '@/layout/components/PanelMeasure';
import WorkspacePanelFull from './WorkspacePanelFull';
import WorkspacePanelNarrow from './WorkspacePanelNarrow';

const WorkspacePanel = ({ configuration }) => (
  <PanelMeasure
    configuration={configuration}
    component={{ full: WorkspacePanelFull, narrow: WorkspacePanelNarrow }}
    width={620}
  />
);

export default WorkspacePanel;
